module.exports = __webpack_public_path__ + "static/media/favicon-trl.7f130600.svg";